import { ExamHexagon } from './examHexagon';

export const UnseenProblem = ExamHexagon;
